module.exports = __webpack_public_path__ + "img/presupuestos.02ba06cc.png";